<template>
  <div>
    <div class="p-4 grid grid-rows-1">
      <div class="grid-cols-1">
        <vx-card>
          <h4 style="font-family: Lora; font-size: x-large">
            Victoria - COVID-19 Data Dashboard:
          </h4>
          <Breadcrumbs
            :breadcrumbs="[
              { title: 'Dashboards', to: `/dashboard` },
              { title: 'Victorian Dashboard', to: '/dashboards/victoria' }
            ]"
          />

          <p class="mt-2">
            Data sourced from Johns Hopkins global cases tracking centre. Data
            updated every 15 minutes.
          </p>
          <p>
            For more information on how this data is collected and maintained,
            please see the
            <a href="https://coronavirus.jhu.edu/" target="_blank"
              >Johns Hopkins Coronavirus Resource Centre</a
            >
          </p>
        </vx-card>
      </div>
    </div>
    <div class="grid grid-rows-1">
      <div
        class=" p-4 grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4 "
      >
        <vx-card title="Victorian Active Cases:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.activeCases"
            :loading="loading"
          />
        </vx-card>
        <vx-card title="Victorian New Cases:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.newCases"
            :loading="loading"
          />
        </vx-card>
        <vx-card title="Victorian Total Cases:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.totalCases"
            :loading="loading"
          />
        </vx-card>
      </div>
    </div>
    <div class="grid grid-rows-1">
      <div
        class=" p-4 grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4 "
      >
        <vx-card title="Victorian Recovered Cases:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.recoveredCases"
            :loading="loading"
          />
        </vx-card>
        <vx-card title="Victorian New Deaths:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.newDeaths"
            :loading="loading"
          />
        </vx-card>
        <vx-card title="Victorian Total Deaths:">
          <GraphTile
            :date-range="dateRange"
            :data-set="dataSets.totalDeaths"
            :loading="loading"
          />
        </vx-card>
      </div>
    </div>
    <div class="grid grid-rows-1">
      <div
        class=" p-4 grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4 "
      >
        <vx-card title="Victorian Total Tests:">
          <GraphTile
            :date-range="reversedDateRange"
            :data-set="[componentVictorianLiveData.dataSets.totalVicTest]"
            :loading="!victorianLiveDataLoaded"
          />
        </vx-card>
        <vx-card title="Victorian Total Hospitalisations:">
          <GraphTile
            :date-range="reversedDateRange"
            :data-set="[componentVictorianLiveData.dataSets.totalVicHospital]"
            :loading="!victorianLiveDataLoaded"
          />
        </vx-card>
        <vx-card title="Victorian Total ICU:">
          <GraphTile
            :date-range="reversedDateRange"
            :data-set="[componentVictorianLiveData.dataSets.totalVicIcu]"
            :loading="!victorianLiveDataLoaded"
          />
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import ActiveCasesCard from "@/modules/dashboard/components/dashboard-cards/ActiveCasesCard";
import NewCasesCard from "@/modules/dashboard/components/dashboard-cards/NewCasesCard";
import TotalCasesCard from "@/modules/dashboard/components/dashboard-cards/TotalCasesCard";
import RecoveredCasesCard from "@/modules/dashboard/components/dashboard-cards/RecoveredCasesCard";
import NewDeathsCard from "@/modules/dashboard/components/dashboard-cards/NewDeathsCard";
import TotalDeathsCard from "@/modules/dashboard/components/dashboard-cards/TotalDeathsCard";
import Breadcrumbs from "@/components/general-components/breadcrumbs/Breadcrumbs";
import { getVictorianData } from "@/modules/dashboard/utilities/victorianStatisticsCalculator";
import GraphTile from "@/modules/dashboard/components/dashboard-cards/GraphTile";
import { mapState } from "vuex";
import _ from "lodash";
export default {
  name: "VictoriaDashboard",
  components: {
    ActiveCasesCard,
    NewCasesCard,
    TotalCasesCard,
    RecoveredCasesCard,
    NewDeathsCard,
    TotalDeathsCard,
    Breadcrumbs,
    GraphTile
  },
  data() {
    return {
      dateRange: [],
      dataSets: [],
      loading: true
    };
  },
  computed: {
    ...mapState(["victorianLiveData", "victorianLiveDataLoaded"]),
    componentVictorianLiveData() {
      return _.cloneDeep(this.victorianLiveData);
    },
    reversedDateRange() {
      let clonedDateRange = _.cloneDeep(
        this.componentVictorianLiveData.dateRange
      );
      return clonedDateRange;
    }
  },
  mounted() {
    getVictorianData()
      .then(victorianData => {
        this.dateRange = victorianData.dateRange;
        this.dataSets.activeCases = [victorianData.dataSets.activeCaseData];
        this.dataSets.newCases = [victorianData.dataSets.newCaseData];
        this.dataSets.totalCases = [victorianData.dataSets.totalCaseData];
        this.dataSets.recoveredCases = [
          victorianData.dataSets.recoveredCaseData
        ];
        this.dataSets.newDeaths = [victorianData.dataSets.newDeathData];
        this.dataSets.totalDeaths = [victorianData.dataSets.totalDeathData];
        this.loading = false;
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>

<style scoped>
.breadcrumb {
  color: #7367f0;
}
</style>
